/**
 * AnalyticsScreen styles
 */

import { StyleSheet } from 'react-native';

import AppStyles from '../../AppStyles';

const styles = StyleSheet.create({
  container: {
    backgroundColor: AppStyles.colorSet.whiteColor,
    height: '100vh',
  },
  // V3: Chip container with compact spacing on mobile
  chipContainer: {
    backgroundColor: AppStyles.colorSet.whiteColor,
    paddingVertical: 4,
    paddingHorizontal: 8,
    marginBottom: 8,
  },
  filterRow: {
    width: '100%',
    flex: 1,
    marginBottom: 16,
    flexDirection: 'row',
    justifyContent: 'space-around',
    zIndex: 1000,
  },
  orgFilterWeb: {
    marginTop: 2,
    marginLeft: 5,
    width: '40%',
  },
  orgFilterMobile: {
    marginTop: 5,
    marginLeft: 1,
    marginBottom: 5,
    width: '100%',
  },
  mobileFilterContainer: {
    width: '100%',
    flex: 1,
    marginBottom: 20,
    marginTop: 5,
    zIndex: 1000,
  },
  // V3: Dropdown styling to match pill aesthetic
  dropdownStyle: {
    backgroundColor: '#F5F5F5',
    borderRadius: 12,
    borderColor: '#E5E5E5',
    borderWidth: 1,
    minHeight: 44,
  },
  dropdownContainerStyle: {
    borderColor: '#E5E5E5',
    borderRadius: 12,
    backgroundColor: '#ffffff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },
  dropdownTextStyle: {
    fontSize: 14,
    color: '#374151',
  },
  dropdownPlaceholderStyle: {
    color: '#6B7280',
  },
  loader: {
    margin: 15,
  },
  // V3: Consistent grid spacing
  statsGrid: {
    flexDirection: 'row',
    paddingHorizontal: 12,
    marginBottom: 16,
    gap: 12,
  },
  statsGridWeb: {
    // Full width on web to align with collapsible sections
  },
  statCardHalf: {
    flex: 1,
  },
  // V3: Consistent section spacing
  chartSection: {
    paddingHorizontal: 12,
    marginBottom: 16,
  },
  // V3: Expand/Collapse all controls
  expandCollapseRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 12,
    marginBottom: 12,
  },
  expandCollapseButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 20,
    backgroundColor: '#F5F5F5',
    borderWidth: 1,
    borderColor: '#E5E5E5',
    minHeight: 36,
  },
  expandCollapseHovered: {
    backgroundColor: '#ECECEC',
    borderColor: AppStyles.colorSet.brandPrimary,
  },
  expandCollapsePressed: {
    backgroundColor: '#E5E5E5',
  },
  expandCollapseText: {
    fontSize: 13,
    fontWeight: '500',
    color: '#6B7280',
    marginLeft: 6,
  },
  cutoffIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    marginTop: 8,
    marginHorizontal: 16,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    gap: 6,
  },
  cutoffIndicatorText: {
    fontSize: 12,
    color: '#4B5563', // Darker gray for better contrast on light background (WCAG AA)
    fontFamily: 'Poppins_400Regular',
  },
});

export default styles;
